import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Contactanos.css";
import { FaPhoneAlt, FaBuilding, FaMapMarkerAlt } from "react-icons/fa";

const Contactanos = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const directorio = [
    { anexo: "4208", dependencia: "Dirección General IESTP “JVA”" },
    { anexo: "4207", dependencia: "Jefatura de Unidad Académica" },
    { anexo: "4206", dependencia: "Jefatura de Unidad Administrativa" },
    { anexo: "4205", dependencia: "Secretaría Académica" },
    { anexo: "4210", dependencia: "Programa de Arquitectura de Plataformas y STI" },
    { anexo: "4204", dependencia: "Programa de Contabilidad" },
    { anexo: "4201", dependencia: "Programa de Enfermería Técnica" },
    { anexo: "4202", dependencia: "Programa de Mecatrónica Automotriz" },
    { anexo: "4203", dependencia: "Programa de Técnica en Farmacia" },
    { anexo: "4209", dependencia: "Vigilancia / Portería" },
  ];

  return (
    <section className="contacto-page">
    
      <div className="contacto-hero" data-aos="fade-down">
        <div className="overlay"></div>
        <div className="container text-center text-white">
          <h1 className="fw-bold">Contáctanos</h1>
          <p className="lead">
            Estamos aquí para atender tus consultas e informarte sobre nuestros servicios.
          </p>
        </div>
      </div>

 
      <div className="container py-5 text-center">
        <h2 className="section-subtitle mb-4 text-primary" data-aos="fade-up">
          Información de Contacto Institucional
        </h2>

        <div className="row g-4 justify-content-center mb-5">
          <div className="col-md-4" data-aos="zoom-in">
            <div className="contact-card">
              <FaPhoneAlt className="contact-icon" />
              <h5 className="fw-bold text-primary">Teléfonos</h5>
              <p>(01) 5707726</p>
              <p>(01) 5006177</p>
            </div>
          </div>

          <div className="col-md-4" data-aos="zoom-in" data-aos-delay="100">
            <div className="contact-card">
              <FaBuilding className="contact-icon" />
              <h5 className="fw-bold text-primary">Institución</h5>
              <p>
                Instituto de Educación Superior Tecnológico Público
                <br /> “Juan Velasco Alvarado”
              </p>
            </div>
          </div>

          <div className="col-md-4" data-aos="zoom-in" data-aos-delay="200">
            <div className="contact-card">
              <FaMapMarkerAlt className="contact-icon" />
              <h5 className="fw-bold text-primary">Ubicación</h5>
              <p>Av. José Olaya Nº 120, San Gabriel, Villa María del Triunfo, Lima, Perú.</p>
            </div>
          </div>
        </div>

     
        <div className="row g-5 justify-content-center align-items-start contacto-grid">
       
          <div className="col-lg-6 d-flex flex-column align-items-center" >
            <h3 className="section-subtitle text-primary mb-3 text-center">
              Directorio Telefónico
            </h3>

            <div className="table-wrapper">
              <div className="table-responsive contact-table">
                <table className="table table-bordered table-striped align-middle">
                  <thead className="table-primary text-center">
                    <tr>
                      <th>Anexo</th>
                      <th>Dependencia</th>
                    </tr>
                  </thead>
                  <tbody>
                    {directorio.map((item, i) => (
                      <tr key={i}>
                        <td className="text-center fw-semibold">{item.anexo}</td>
                        <td>{item.dependencia}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

      
          <div className="col-lg-6 d-flex flex-column align-items-center" >
            <h3 className="section-subtitle text-primary mb-3 text-center">
              Ubicación en el Mapa
            </h3>
            <div className="map-wrapper">
              <iframe
                title="Ubicación Instituto Juan Velasco Alvarado"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3900.7537335407123!2d-76.9703424!3d-12.131021899999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9105c77fcae45e29%3A0x85cdd674cb4937d2!2sInstituto%20Juan%20Velasco%20Alvarado!5e0!3m2!1ses!2spe!4v1699472578881!5m2!1ses!2spe"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contactanos;
